import {
  CampaignDetailModelState,
  ContractActionRequestContractAction,
} from '@urbanx/agx.campaigns.client'
import {
  NswContractStage,
  QldContractStage,
} from '@urbanx/agx-ui-components'
import { ActionMenu } from '@urbanx/agx.ui-components2'

interface ContractOptionsProps {
  contractId: string
  campaignState?: CampaignDetailModelState
  stage?: NswContractStage | QldContractStage
  onPerformContractAction(
    contractId: string,
    contractAction: ContractActionRequestContractAction
  ): void
  dataTestId?: string
}

const ContractOptions = ({
  contractId,
  campaignState,
  stage,
  onPerformContractAction,
  dataTestId,
}: ContractOptionsProps) => {
  const actionsByStage = (contractStage?: NswContractStage | QldContractStage) => {
    if (campaignState === CampaignDetailModelState.QLD) {
      if (
        contractStage === QldContractStage.BackUp ||
        contractStage === QldContractStage.PendingCompliance
      ) {
        return [
          {
            action: ContractActionRequestContractAction.MarkAsAccepted,
            children: 'Mark as Accepted',
          },
          {
            action: ContractActionRequestContractAction.Terminated,
            children: 'Terminated',
          },
        ]
      }

      if (contractStage === QldContractStage.Accepted) {
        return [
          {
            action: ContractActionRequestContractAction.MarkAsUnconditional,
            children: 'Mark as Unconditional',
          },
          {
            action: ContractActionRequestContractAction.Terminated,
            children: 'Terminated',
          },
        ]
      }

      if (contractStage === QldContractStage.Unconditional) {
        return [
          {
            action: ContractActionRequestContractAction.MarkSettled,
            children: 'Mark as Settled',
          },
          {
            action: ContractActionRequestContractAction.Terminated,
            children: 'Terminated',
          },
        ]
      }

      return []
    }

    if (campaignState !== CampaignDetailModelState.NSW) return []

    if (contractStage === NswContractStage.ContractRequested) {
      return [
        {
          action: ContractActionRequestContractAction.MarkAsAwaitingExchange,
          children: 'Mark as Awaiting Exchange',
        },
      ]
    }

    if (contractStage === NswContractStage.AwaitingExchange) {
      return [
        {
          action: ContractActionRequestContractAction.MarkAsAccepted,
          children: 'Mark as Accepted',
        },
        {
          action: ContractActionRequestContractAction.Cancelled,
          children: 'Cancelled',
        },
      ]
    }

    if (contractStage === NswContractStage.PendingCompliance) {
      return [
        {
          action: ContractActionRequestContractAction.MarkAsAccepted,
          children: 'Mark as Accepted',
        },
        {
          action: ContractActionRequestContractAction.Terminated,
          children: 'Terminated',
        },
      ]
    }

    if (contractStage === NswContractStage.Accepted) {
      return [
        {
          action: ContractActionRequestContractAction.MarkAsUnconditional,
          children: 'Mark as Unconditional',
        },
        {
          action: ContractActionRequestContractAction.Terminated,
          children: 'Terminated',
        },
      ]
    }

    if (contractStage === NswContractStage.Unconditional) {
      return [
        {
          action: ContractActionRequestContractAction.MarkSettled,
          children: 'Mark as Settled',
        },
        {
          action: ContractActionRequestContractAction.Terminated,
          children: 'Terminated',
        },
      ]
    }

    return []
  }

  const actions = actionsByStage(stage)

  return (
    <ActionMenu
      actions={actions}
      id={contractId}
      onAction={(action) => onPerformContractAction(contractId, action)}
      dataTestId={dataTestId}
    />
  )
}

export default ContractOptions
